module.exports = __webpack_public_path__ + "static/media/background.19c49860.svg";